<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Signature Details</v-card-title>

    <v-card-text
        v-if="check != null"
    >
        
       <div v-if="check.latest_signed_packet == null">
           This user has not signed a EULA packet.
       </div>

       <div v-if="check.latest_signed_packet != null">
        
           Documents:
           
           <m-signature-packet-documents
                :meta_data="meta_data"
           />

             <v-text-field
                label="Version"
                :value="check.latest_signed_packet.version"
                disabled
            />

            <v-text-field
                label="Signed On"
                :value="new Date(check.latest_signature.signed_time)"
                disabled
                autocomplete="off"
            />

       </div>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

       
        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

export default {


    data() {
        return {
            dialog: false,
            check: null,
            meta_data: [],
        }
    },

    methods: {

        showDialog(employee_id) 
        {
            this.dialog = true;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/eula/signatures/:employee_id',
            
                'params' : {
                        'employee_id': employee_id,
                    },
            
                'on_success': (check) => {
                         this.check = check;
                        this.getBlobMetaData();
                    },
            
                'on_error': 'Unable to get signature'
            });
        },

        getBlobMetaData()
        {
            if ( this.check == null ) return;
            if ( this.check.latest_signed_packet == null ) return;


            this.$rc.showSpinner();

            this.$rc.getBlobMetaDataMultiple(
                this.check.latest_signed_packet.blob_ids,

                (data) => {
                    this.$rc.hideSpinner();
                    this.meta_data = data.meta_data;
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error', 'Unable to get blob meta data');
                }
            )
        },
        
        onOk()
        {
            this.dialog = false;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>